/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Table, TableColumnsType} from "antd";
import dayjs from "dayjs";
import {BaechaUpdateHistory} from "../../../types/BaechaUpdateHistory";
import {formatKorDate} from "../../../util/date";

interface BaechaUpdateHistoryTableProps {
	data: BaechaUpdateHistory[];
}

const BaechaUpdateHistoryTable = ({ data }: BaechaUpdateHistoryTableProps) => {
	if (data.length === 0) return null;
	return (
		<Table
			bordered
			size='small'
			style={{ tableLayout: 'fixed', width: '100%' }}
			pagination={false}
			dataSource={data.map((row) => ({...row, key: row.id}))}
			columns={[
				{
					title: '생성일시',
					dataIndex: 'createDate',
					key: 'createDate',
					width: 30,
					align: 'center',
					render: (text: string) => (
						<div style={{ fontVariantNumeric: 'tabular-nums' }}>
							{formatKorDate(text)} {dayjs(text).format('HH:mm')}
						</div>
					)
				},
				{
					title: '닉네임',
					dataIndex: 'nickname',
					key: 'nickname',
					width: 10,
					align: 'center',
				},
				{
					title: '메시지',
					dataIndex: 'message',
					key: 'message',
					width: 50,
					align: 'center',
					render: (text: string) => (<div style={{ textAlign: 'left' }}>{text}</div>)
				},

			] as TableColumnsType<BaechaUpdateHistory>}
		/>
	);
}

export default BaechaUpdateHistoryTable;
